import React, { useState } from 'react';
import {
  DetailedProviderContent,
  CARE_TEAM
} from '@kyruus/provider-components';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import messages from '../../lib/messages';
import { TrackingFunction, trackShowMoreClick } from '../../lib/tracking-utils';
import { PROFILE_SECTION_IDS } from '../../lib/constants';

import {
  CareTeamProviderList,
  ShowMoreButton,
  CareTeamExpandedProviderList
} from './styles';

const INITIAL_PROVIDERS_TO_SHOW = 4;
interface CareTeamListProps extends WrappedComponentProps {
  careTeamProviders: DetailedProviderContent[];
  createAvailabilityUrl: () => string;
  createProviderUrl: () => string;
  track: TrackingFunction;
}

export const CareTeamList = injectIntl(
  ({
    intl,
    careTeamProviders,
    createAvailabilityUrl,
    createProviderUrl,
    track
  }: CareTeamListProps) => {
    const [isListExpanded, setIsListExpanded] = useState(false);

    const handleClickShowMore = () => {
      if (isListExpanded) {
        trackShowMoreClick(track, 'hide', CARE_TEAM);
      } else {
        trackShowMoreClick(track, 'show', CARE_TEAM);
      }
      setIsListExpanded(!isListExpanded);
    };

    const showMoreAriaLabel = isListExpanded
      ? intl.formatMessage(messages.careTeamShowLessAriaLabel)
      : intl.formatMessage(messages.careTeamShowMoreAriaLabel);

    return (
      <>
        <CareTeamProviderList
          providers={careTeamProviders.slice(0, INITIAL_PROVIDERS_TO_SHOW)}
          track={track}
          createAvailabilityUrl={createAvailabilityUrl}
          createProviderUrl={createProviderUrl}
          renderType={CARE_TEAM}
        />
        {careTeamProviders.length > INITIAL_PROVIDERS_TO_SHOW ? (
          <>
            {isListExpanded && (
              <CareTeamExpandedProviderList
                providers={careTeamProviders.slice(INITIAL_PROVIDERS_TO_SHOW)}
                track={track}
                createAvailabilityUrl={createAvailabilityUrl}
                createProviderUrl={createProviderUrl}
                renderType={CARE_TEAM}
              />
            )}
            <ShowMoreButton
              type="button"
              onClick={handleClickShowMore}
              aria-label={showMoreAriaLabel}
              aria-expanded={isListExpanded}
              aria-controls={PROFILE_SECTION_IDS.CARE_TEAM}
            >
              {isListExpanded
                ? intl.formatMessage(messages.careTeamShowLess)
                : intl.formatMessage(messages.careTeamShowMore)}
            </ShowMoreButton>
          </>
        ) : null}
      </>
    );
  }
);
